<div class="copago-carencia-text" [innerHTML]="'PYMES.COPAGO-CARENCIA.TEXT' | translate"> </div>